export default __webpack_public_path__ + "static/media/english-to-korean-mobile-2.b06ae074.png";